export const getPageLocale = () => {
    const defaultLocale = "en-us";
    const locale = window.location.hostname.match(/.cn$/)
        ? "zh-cn"
        : window.location.pathname?.split("/")?.[1] ||
          document.documentElement.lang ||
          defaultLocale;

    // ensure locale is in the format xx-xx.
    return /^[a-z]{2}-[a-z]{2}$/i.test(locale) ? locale : defaultLocale;
};

export const isCNTLD = () => {
    return location.host.includes(".cn");
};

export const setLocaleSeparator = (locale, separator) => {
    return locale.replace(/-|_/g, separator);
};

export const convertLocaleFormat = (locale, format) => {
    if (!locale) {
        return "";
    }

    // first normalize the separator for split
    const localeSplit = setLocaleSeparator(locale, "-").split("-");

    switch (format) {
        case "xx_XX":
            return `${localeSplit[0].toLowerCase()}_${localeSplit[1].toUpperCase()}`;
        case "xx-xx":
        default:
            return `${localeSplit[0]}-${localeSplit[1]}`.toLowerCase();
    }
};
export const addTrailingSlash = (url, shouldReplace) => {
    //check if url has trailing slash
    let splitUrl = url.split("?");
    let pathname = url;
    let searchPath = splitUrl[1];
    if (splitUrl.length > 1) {
        pathname = splitUrl[0];
    }

    if (pathname[pathname.length - 1] !== "/") {
        let newUrl = pathname + "/";
        if (searchPath) {
            newUrl += "?" + searchPath;
        }
        if (shouldReplace) {
            window.history.replaceState({}, null, newUrl);
        }

        return newUrl;
    }

    return url;
};

export const getVoltronBase = () => {
    if (isCNTLD()) {
        return VOLTRON_BASE_CN;
    }
    return VOLTRON_BASE;
};

export const getAssetBase = () => {
    if (isCNTLD()) {
        return API_URLS.ASSETS_BASE_CN;
    }
    return API_URLS.ASSETS_BASE;
};
